import type { Column } from 'react-table';
import { Chip, styled, Typography } from '@mui/material';
import { TableCell, TableHeader } from 'redesign';
import { IconFlexPoolOnlyJob } from 'assets/img';
import { useGetShiftDetailsColumnDefinitionBase } from 'shared/components/shift-detail-modal/components/tabs/shared/columns/use-get-shift-details-column-definition-base';
import { CancelledCellProps } from 'shared/components/shift-detail-modal/components/tabs/cancelled/helpers/cancelled-table.types';
import { useTranslation } from 'react-i18next';
import { CancelledColumnDefinitionProject } from '../types/cancelled-table-project.types';

export const useGetCancelledColumnDefinitionProject: () => Column<CancelledColumnDefinitionProject>[] =
  () => {
    const { t } = useTranslation('hq-screen-specific');
    const [flexWorkerImage, fw] = useGetShiftDetailsColumnDefinitionBase();

    const cancellationReason: Column<CancelledColumnDefinitionProject> = {
      Header: '',
      accessor: 'cancellationReason',
      Cell: CancellationReasonCell,
    };

    const flexPoolIndicator: Column<CancelledColumnDefinitionProject> = {
      Header: '',
      accessor: 'flexPoolIndicator',
      Cell: FlexPoolIndicatorCell,
    };
    const hourlyRate: Column<CancelledColumnDefinitionProject> = {
      Header: () => (
        <TableHeader>
          {t('projects.cancellations.table_headers.hourly_rate', { ns: 'hq-screen-specific' })}
        </TableHeader>
      ),
      accessor: 'hourlyRate',
      Cell: HourlyRateCell,
    };

    return [flexWorkerImage, cancellationReason, flexPoolIndicator, fw, hourlyRate];
  };

const HourlyRateCell = ({ value }: CancelledCellProps<'hourlyRate'>) => {
  return (
    <TableCell>
      {value.toLocaleString('nl-NL', {
        style: 'currency',
        currency: 'EUR',
      })}
    </TableCell>
  );
};

const FlexPoolIndicatorCell = ({ value }: CancelledCellProps<'flexPoolIndicator'>) => {
  return value ? <IconFlexPoolOnlyJob width={24} /> : null;
};

const CancellationReasonCell = ({ value }: CancelledCellProps<'cancellationReason'>) => {
  return <StyledChip size="small" label={<Typography variant="body2">{value}</Typography>} />;
};

const StyledChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.warning.main,
}));
